const qiniu = require('qiniu-js')
import Vue from 'vue'
import { getAction } from "@/api/manage"
import { randomUUID } from "./util"
import { TENANT_CONFIG } from "@/store/mutation-types";
/**
 * 上传文件至七牛
 * @param {*} file 
 * @param {*} fileName 
 * @param {*} observer 
 */
export function upload2Qiniu(file, fileName, observer) {
    if (observer == null) {
        observer = {
            next(res) {
                var percent = Math.round(res.total.percent)
                console.log("上传中", percent);
            },
            error(err) {
                console.log(err)
                console.log("上传失败", err);
            },
            complete(res) {
                key = res.key
                console.log("上传成功", key);
            }
        }
    }
    let filenamePart = fileName.split(".")
    let suffix = ""
    if (filenamePart.length > 1) {
        suffix = filenamePart[filenamePart.length - 1]
    }
    var that = this
    getQiniuToken().then(token => {
        var key = randomUUID() + "." + suffix
        if (fileName == null) { fileName = key }
        var config = {
            useCdnDomain: true,
            region: Vue.ls.get(TENANT_CONFIG).qiniuArea,
            // region: null,
            disableStatisticsReport: false
        }
        var putExtra = {
            fname: fileName, //文件原名
            params: {},
            mimeType: null
        }
        var observable = qiniu.upload(file, key, token, putExtra, config)
        var subscription = observable.subscribe(observer)
    })
}

/**
 * 获取七牛Token
 */
export function getQiniuToken() {
    if (Vue.ls.get("qiniuToken")) {
        return new Promise((resolve) => {
            resolve(Vue.ls.get("qiniuToken"))
        })
    } else {
        return new Promise((resolve, reject) => {
            return getAction("/common/qiniu/getToken").then(res => {
                if (res.success) {
                    Vue.ls.set("qiniuToken", res.result, 600000)
                    resolve(res.result)
                } else {
                    reject(res.message)
                }
            })
        })
    }
}

/**
 * 获取七牛访问地址
 * @param {七牛key} text 
 * @param {刷新缓存} forceCache 
 * @returns 
 */
export function getQiniuUrl(text, forceCache){
    if(!text){
        //this.$message.warning("未知的文件")
        return;
    }
    if(text.indexOf(",")>0){
        text = text.substring(0,text.indexOf(","))
    }
    if(text.startsWith("http")){
        return text
    }
    return Vue.ls.get(TENANT_CONFIG).qiniuDomain + '/' + text + (forceCache ? '?v=' + new Date().getTime() : '');
}

/**
 * 下载七牛文件
 * @param {七牛key} text 
 * @param {下载文件名} filename 
 * @param {刷新缓存} forceCache 
 * @returns 
 */
export function getQiniuFile(path, filename, forceCache) {
    if (!path) {
        //this.$message.warning("未知的文件")
        return;
    }
    if (path.indexOf(",") > 0) {
        path = path.substring(0, path.indexOf(","))
    }
    // if(!filename){
    //     filename = path.split('/').pop();
    // }
    if (!path.startsWith("http")) {
        path = this.$store.getters.tenantInfo.qiniuDomain + '/' + path
    }
    path = path + (path.includes("?") ? '&' : '?')
    if(filename){
        path = path + 'attname=' + filename + '&'
    }
    window.open(path + (forceCache ? 'v=' + new Date().getTime() : ''));
}

/**
 * 下载文件，而不是通过浏览器打开
 */
export function downloadFile(url, filename) {
    getAction(url).then((res) => {
        res.blob().then((blob) => {
            const blobUrl = window.URL.createObjectURL(blob);
            // 这里的文件名根据实际情况从响应头或者url里获取
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;;
            a.click();
            window.URL.revokeObjectURL(blobUrl);
        });
    });
}

/**
 * base64转blob
 * @param {base64} dataurl 
 * @returns 
 */
export function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}